import * as tslib_1 from "tslib";
import mountAndShowFullOptions from '../../utils/mountAndShowFullOptions';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
var styles = require('./QuickOptions.scss');
var classNames = require('classnames/bind').bind(styles);
var QuickOptionSearchEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionSearchEntry, _super);
    function QuickOptionSearchEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHeaderClick = function () {
            mountAndShowFullOptions(_this.props.option.categoryKey, _this.props.option.subcategoryKey, _this.props.option.key);
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        return _this;
    }
    QuickOptionSearchEntry.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement(CommandButton, { text: strings[option.titleStringKey], className: classNames(styles.quickSettingHeader, styles.isSearch), onClick: this.onHeaderClick })));
    };
    QuickOptionSearchEntry = tslib_1.__decorate([
        observer
    ], QuickOptionSearchEntry);
    return QuickOptionSearchEntry;
}(React.Component));
export default QuickOptionSearchEntry;
//# sourceMappingURL=QuickOptionSearchEntry.js.map